import Vuetify from 'vuetify';
import Vue from 'vue';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'vuetify/dist/vuetify.min.css';

import { NsIcon } from '@nuskin/ns-icon';
import NsAlert from './components/NsAlert.vue';
import NsAnimateHeight from './components/NsAnimateHeight.vue';
import NsAvatar from './components/NsAvatar.vue';
import NsBadge from './components/NsBadge.vue';
import NsBifrostButton from './components/NsBifrostButton.vue';
import NsCard from './components/NsCard.vue';
import NsCarousel from './components/NsCarousel.vue';
import NsCheckBox from './components/NsCheckbox.vue';
import NsDatePicker from './components/NsDatePicker.vue';

import NsEmailSimple from './components/NsEmailSimple.vue';
import NsExpressiveLink from './components/NsExpressiveLink.vue';
import NsLightbox from './components/NsLightbox.vue';
import NsModal from './components/NsModal.vue';
import NsOktaPassword from './components/NsOktaPassword.vue';
import NsPassword from './components/NsPassword.vue';
import NsPhoneNumber from './components/NsPhoneNumber.vue';
import NsPhoneNumberLib from './components/NsPhoneNumberLib.vue';
import NsPhoneNumberFormats from './components/phoneFormats.js';
import NsPopup from './components/NsPopup.vue';
import NsProgress from './components/NsProgress.vue';
import NsRadioGroup from './components/NsRadioGroup.vue';
import NsSelect from './components/NsSelect.vue';
import NsSlottedDropdown from './components/NsSlottedDropdown.vue';
import NsSpinner from './components/NsSpinner.vue';
import NsTab from './components/NsTab.vue';
import NsTabs from './components/NsTabs.vue';
import NsTabsItems from './components/NsTabsItems.vue';
import NsTable from './components/NsTable.vue';
import NsTextField from './components/NsTextField.vue';
import NsVTextField from './components/NsVTextField.vue';
import NsToast from './components/NsToast.vue';
// credit card
import NsCedynaForm from './components/payment/NsCedynaForm.vue';
import NsCreditCard from './components/payment/NsCreditCard.vue';
import NsCreditCardDate from './components/payment/NsCreditCardDate.vue';
import NsCreditCardForm from './components/payment/NsCreditCardForm.vue';
import NsSepaForm from './components/payment/NsSepaForm.vue';
import NsCvvForm from './components/payment/NsCvvForm.vue';
import NsExpireDateForm from './components/payment/NsExpireDateForm.vue';
import PaymentType from './components/payment/paymentType.js';
// tax id
import NsTaxId from './components/ns-taxid/NsTaxId.vue';
// dynamic fieldset
import NsDynamicFieldset from './components/ns-dynamic-fieldset/NsDynamicFieldset.vue';

window.Vue = Vue;
Vue.config.silent = true;
const NsIcons = {
  prev: {
    component: NsIcon,
    props: {
      iconName: 'icon-chevron-left',
      size: 'icon-sm',
    },
  },
  next: {
    component: NsIcon,
    props: {
      iconName: 'icon-chevron-right',
      size: 'icon-sm',
    },
  },
  'date-prev': {
    component: NsIcon,
    props: {
      iconName: 'icon-circle-chevron-left',
      size: 'icon-sm',
    },
  },
  'date-next': {
    component: NsIcon,
    props: {
      iconName: 'icon-circle-chevron-right',
      size: 'icon-sm',
    },
  },
  'ns-clear': {
    component: NsIcon,
    props: {
      iconName: 'icon-circle-close-light',
      size: 'icon-sm',
    },
  },
};
Vue.use(Vuetify, {
  iconfont: 'md',
  icons: NsIcons,
});

export {
  NsRadioGroup,
  NsCheckBox,
  NsAvatar,
  NsBadge,
  NsSelect,
  NsIcon,
  NsPassword,
  NsOktaPassword,
  NsAlert,
  NsToast,
  NsModal,
  NsBifrostButton,
  NsCreditCard,
  NsCreditCardDate,
  NsCreditCardForm,
  NsSepaForm,
  NsCedynaForm,
  NsCvvForm,
  NsPhoneNumber,
  NsPhoneNumberLib,
  NsPhoneNumberFormats,
  NsPopup,
  NsTextField,
  NsVTextField,
  NsExpressiveLink,
  NsCarousel,
  NsSlottedDropdown,
  PaymentType,
  NsSpinner,
  NsTaxId,
  NsProgress,
  NsDynamicFieldset,
  NsExpireDateForm,
  NsTable,
  NsCard,
  NsAnimateHeight,
  NsLightbox,
  NsTab,
  NsTabs,
  NsTabsItems,
  NsDatePicker,
  NsEmailSimple,
};
